import React from "react";
import "../styles/projects.css";
import { motion } from "framer-motion";

import { projects } from "./constants/index";

const Project = ({ name, description, tags, source_code_link }) => {
  return (
    <div className="card">
      <div className="project__about">
        <h3>{name}</h3>
        <p className="project__about__text">{description}</p>
        <div className="project__tags">
          {tags.map((tag, index) => (
            <span className="tag" key={index}>
              {tag}
            </span>
          ))}
        </div>
      </div>
      <a
        className="project__links"
        href={source_code_link}
        rel="noreferrer"
        target="_blank"
      >
        Source Code
        <svg
          fill="currentColor"
          height="1em"
          stroke="currentColor"
          strokeWidth="0"
          viewBox="0 0 1024 1024"
          width="1em"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z"></path>
        </svg>
      </a>
    </div>
  );
};

function Projects() {
  return (
    <motion.div
      className="project__main page"
      variants={{
        hidden: { opacity: 0, y: 75 },
        visible: { opacity: 1, y: 0 },
      }}
      initial="hidden"
      animate="visible"
      transition={{ duration: 0.5, delay: 0.25 }}
    >
      <h1 className="page-heading">Projects</h1>
      <p className="page-subtitle">
        Platform and DevOps work at Egnyte, plus web projects from earlier days
      </p>

      <div className="cards">
        {projects.map((project, index) => (
          <Project
            key={index}
            name={project.name}
            description={project.description}
            tags={project.tags}
            source_code_link={project.source_code_link}
          />
        ))}
      </div>
    </motion.div>
  );
}

export default Projects;
